import { render } from "./SurveyComponent.vue?vue&type=template&id=6e592c43&ts=true"
import script from "./SurveyComponent.vue?vue&type=script&lang=ts"
export * from "./SurveyComponent.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\a\\1\\s\\src\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__